import React, {
  ComponentPropsWithoutRef,
  useMemo,
} from 'react';
import ActionMenu from '../../components/actionMenu/ActionMenu';
import Offer from '../../types/Offer.interface';

const OffersListItemMenu = ({ getActions, offer }: {
  getActions: (_offer: Offer) => ComponentPropsWithoutRef<typeof ActionMenu>['actions'], offer: Offer
}) => {
  const actions = useMemo(
    () => {
      if (!getActions || !offer) return [];
      return getActions(offer);
    },
    [offer],
  );

  return (
    <ActionMenu
      suppressPrimary
      actions={actions}
    />
  );
};

export default OffersListItemMenu;
